module.exports = __webpack_public_path__ + "static/media/ella-mono-black.a82413e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/ella-mono-black.svg
// module id = 103
// module chunks = 0